export default __webpack_public_path__ + "static/3-281ec43ada50fa00fccc98df04056dd8.png";